import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { HandlesFinishFields } from '@/components/features/finishes/HandlesFinishFields'

interface HandlesFinishSectionProps {
  // General finish from project defaults
  generalFinish?: {
    model: string
    color: string
  }
  
  // Current values
  useGeneral: boolean
  customModel?: string
  customColor?: string
  
  // Callbacks
  onUseGeneralChange: (useGeneral: boolean) => void
  onCustomModelChange: (model: string) => void
  onCustomColorChange: (color: string) => void

  // Dialog control (headless mode)
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function HandlesFinishSection({
  generalFinish: _generalFinish,
  useGeneral,
  customModel = '',
  customColor = '',
  onUseGeneralChange,
  onCustomModelChange,
  onCustomColorChange,
  open,
  onOpenChange,
}: HandlesFinishSectionProps) {
  return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="sm:max-w-[500px]">
          <DialogHeader>
            <DialogTitle>Poignées</DialogTitle>
          </DialogHeader>

          <div className="py-4 space-y-4">
            <div className="space-y-2">
              <Label>Mode</Label>
              <div className="flex gap-4 text-sm">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    checked={useGeneral}
                    onChange={() => onUseGeneralChange(true)}
                    className="w-4 h-4"
                  />
                  <span>Finition de base</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    checked={!useGeneral}
                    onChange={() => onUseGeneralChange(false)}
                    className="w-4 h-4"
                  />
                  <span>Spécifique</span>
                </label>
              </div>
              
            </div>

            {!useGeneral && (
              <div className="space-y-3">
                <p className="text-xs text-muted-foreground">
                  Définissez ici le modèle et le coloris des poignées pour ce meuble. Les champs marqués d&apos;une * sont obligatoires.
                </p>
                <HandlesFinishFields
                  model={customModel}
                  onModelChange={onCustomModelChange}
                  color={customColor}
                  onColorChange={onCustomColorChange}
                />
              </div>
            )}
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Annuler
            </Button>
            <Button
              type="button"
              onClick={() => onOpenChange(false)}
              disabled={!useGeneral && (!customModel || !customColor)}
            >
              Appliquer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  )
}
